import {getLoadedWorkerFlags, isPageOnlyFlag} from '@config/modes';
import {CURRENT_ACCOUNT_QUERY_PARAM} from '@lib/accounts/constants';
import {THREADED_WORKER_PROTOCOL_QUERY_PARAM} from '@lib/threadedWorkerTypes';

export function makeWorkerURL(url: string | URL) {
  if(!(url instanceof URL)) {
    url = new URL(url + '', location.href);
  }

  if(url.protocol !== 'blob:') {
    const params = new URLSearchParams(location.search);
    params.forEach((value, key) => {
      if(key === CURRENT_ACCOUNT_QUERY_PARAM || key === THREADED_WORKER_PROTOCOL_QUERY_PARAM || isPageOnlyFlag(key)) return;
      (url as URL).searchParams.set(key, value);
    });

    // * and the flags kept on for the site, which the worker cannot read itself
    getLoadedWorkerFlags().forEach((flag) => {
      (url as URL).searchParams.set(flag, '1');
    });
  }

  // exclude useless params
  (url as URL).searchParams.delete('swfix');

  return url;
}

export default function setWorkerProxy() {
  // * hook worker constructor to set search parameters (test, debug, etc)
  const workerHandler = {
    construct(target: any, args: any) {
      args[0] = makeWorkerURL(args[0]);
      return new target(...args);
    }
  };

  [
    typeof(Worker) !== 'undefined' && Worker,
    typeof(SharedWorker) !== 'undefined' && SharedWorker
  ].filter(Boolean).forEach((w) => {
    window[w.name as any] = new Proxy(w, workerHandler);
  });
}

setWorkerProxy();
